// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header.header-page-audience .back-container.hidden {
  display: block;
}
.page-audience .page-title {
  margin-top: 0;
  color: var(--orange);
  font-size: 34px;
  font-weight: 700;
  line-height: 40px;

  margin-bottom: 0;
}

.page-audience .page-description {
  font-size: 20px;
  font-weight: 600;

  margin: 8px 0 40px;
}

.page-audience .button-container {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/audience.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["#header.header-page-audience .back-container.hidden {\n  display: block;\n}\n.page-audience .page-title {\n  margin-top: 0;\n  color: var(--orange);\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 40px;\n\n  margin-bottom: 0;\n}\n\n.page-audience .page-description {\n  font-size: 20px;\n  font-weight: 600;\n\n  margin: 8px 0 40px;\n}\n\n.page-audience .button-container {\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
